<!-- This a template for ng-tags-input directive -->

<span class="decipher-tags-tag"
      data-ng-class="getClasses(tag)">{{tag.name}}
      <i class="icon-remove"
         data-ng-click="remove(tag)">
      </i>
</span>
